import { IComponentOptions } from "angular";
import {
  getProcessTimelineDetailComponent,
  ProcessTimelineDetailComponentController,
} from "../detailComponent";
import { ProcessTransactions } from "../../../../../model/ProcessTransaction";
import { StateIntervalTimelineData } from "./source";

class StateIntervalController extends ProcessTimelineDetailComponentController<StateIntervalTimelineData> {
  static $inject: string[] = [];

  get startEvent(): ProcessTransactions | undefined {
    return this.model?.startEvent;
  }

  get endEvent(): ProcessTransactions | undefined {
    return this.model?.endEvent;
  }
}

export const StateIntervalComponentOptions: IComponentOptions =
  getProcessTimelineDetailComponent<
    StateIntervalTimelineData,
    StateIntervalController
  >({
    template: require("!html-loader!./index.html").default,
    controller: [() => new StateIntervalController()],
  });
